import * as Constants from './mutation-types';
import * as Actions from './action-types';
import localStorage from '../helpers/localStorage';
import Endpoints from '../api';
import {cartUpdater, arrayToObjectLikeArray, addKeyToProducts} from "../helpers/productHelper";

export const productActions = {
    [Actions.getFlexTickets]({commit}) {
        Endpoints.flex.get({pur_type: 'FLEX'})
            .then(tickets => commit(Constants.ADD_FLEX_TICKETS, {tickets}))
            .catch(errors => console.log(`Flex ticket request fail`, errors));
    },

    [Actions.addFlexTickets]({commit}, payload) {
        commit(Constants.ADD_FLEX_TICKETS, payload)
    },

    [Actions.addTodayProducts]({commit}, payload) {
        commit(Constants.ADD_TODAY_PRODUCTS, payload)
    },

    [Actions.getTicketsAndCart]({commit}) {
        const {id} = localStorage.get('cart');

        Endpoints.flex.get({pur_type: 'FLEX'}).then(data => {
            if (id) getCartInfo(id, data, commit);
            else commit(Constants.ADD_FLEX_TICKETS, {tickets: data});
        })
    },

    [Actions.setWeekdayOnly]({commit}, payload) {
        commit(Constants.SET_WEEKDAYS_ONLY, payload);
    }
};

const getCartInfo = (id, tickets, commit) => {
    Endpoints.cart.get({id}).then(cart => {
        mergeQuantity(tickets, cart, commit);
        commit(Constants.ADD_FLEX_TICKETS, {tickets});
        if (cart) commit(Constants.RESTORE_CART_PRODUCTS, {products: cart.products})
    }).catch((e) => {
        if (e.response.status === 404) localStorage.destroy('cart');

        commit(Constants.ADD_FLEX_TICKETS, {tickets})
    });
};

/**
 * Merge quantity from ticket and cart
 *
 * @param tickets
 * @param cart
 * @param commit
 */
export const mergeQuantity = (tickets, cart, commit) => {
    if (!cart) return;

    const {products} = cart;
    let ticket = {};

    tickets.forEach(t => {
        t.products.map(p => {
            const product = products.find(pr => p.product_id === pr.product_id);
            if (product) {
                ticket = t;
                p.quantity = product.quantity;
            }
            return p;
        });
    });

    commit(Constants.SET_CURRENT_TICKET, {ticket});
};

export const cartActions = {
    [Actions.addProductToCart](context, payload) {
        const {commit, state, dispatch} = context;
        commit(Constants.ADD_PRODUCTS_TO_CART, payload);
        cartUpdater(state.cart, dispatch);
    },
    [Actions.getCartPasses](context) {
        const {commit, state, dispatch} = context;
        Endpoints.passes.get_cart.post().then(cart => {
            commit(Constants.PASSES_CART, cart);
        }).catch((e) => {
            if (e.response.status === 404) localStorage.destroy('passes_cart');
        });
    },

    [Actions.removeProductFromCart](context, payload) {
        const {commit, dispatch} = context;
        commit(Constants.REMOVE_PRODUCT_TO_CART, {...payload, dispatch});
    },

    [Actions.restoreCart]({commit}) {
        const {id} = localStorage.get('cart');
        if (!id) return;
        Endpoints.cart.get({id})
            .then(data => commit(Constants.RESTORE_CART_PRODUCTS, {products: data.products}))
            .catch((e) => {
                if (e.response.status === 404) {
                    localStorage.destroy('cart')
                }
            });
    },

    [Actions.mergeLocalAndRemoteCart]({commit}, payload) {
        commit(Constants.MERGE_LOCAL_AND_REMOTE_CART, payload);
    }
};

export const footerActions = {
    [Actions.toggleFooter]({commit}, payload) {
        commit(Constants.TOGGLE_FOOTER, payload);
    }
};

export const flexActions = {
    [Actions.toggleWeekDaysSwitch]({commit}, payload) {
        commit(Constants.TOGGLE_WEEKDAY_SWITCH, payload);
    }
};

const mergeProductQuantity = (fixTickets, products, duration) => {

    if (!products || !products.length) return fixTickets;

    return fixTickets.map(fixTicket => {
        if (fixTicket.ticket) {
            fixTicket.ticket.products = fixTicket.ticket.products.map(p => {
                const product = products.find(
                    pr => `${p.product_id}_${fixTicket.date}_${duration}` === pr.key
                );
                if (product) p.quantity = product.quantity;
                return p;
            })
        }

        return fixTicket
    });
};

export const fixActions = {
    [Actions.setDaysQuantity]({commit}, payload) {
        commit(Constants.SET_DAYS_QUANTITY, payload);
    },
    [Actions.setStartDate]({commit}, payload) {
        commit(Constants.SET_START_DATE, payload);
    },
    [Actions.setEndtDate]({commit}, payload) {
        commit(Constants.SET_END_DATE, payload);
    },

    async [Actions.getFixTicketsAndCart]({commit, state}, params) {
        commit(Constants.SET_LOADING_STATUS, {status: true});
        const fixTickets = await Endpoints.fix.get(params);

        try {
            const {id} = localStorage.get('cart');
            const cart = await Endpoints.cart.get({id});
            const products = addKeyToProducts(cart.products);
            const tickets = mergeProductQuantity(fixTickets, products, state.daysQuantity);

            commit(Constants.RESTORE_CART_PRODUCTS, {products: products});
            commit(Constants.SET_FIX_TICKETS, {fixTickets: arrayToObjectLikeArray(tickets)});
        } catch (e) {
            console.error(e);
            commit(Constants.SET_FIX_TICKETS, {fixTickets: arrayToObjectLikeArray(fixTickets)});
        }
        commit(Constants.SET_LOADING_STATUS, {status: false});
        Bus.$emit('select-calendar-day');
    },

    async [Actions.getFixTickets]({commit, state}, params) {
        commit(Constants.SET_LOADING_STATUS, {status: true});
        commit(Constants.REMOVE_FIX_TICKETS);

        const fixTickets = await Endpoints.fix.get(params);
        const products = state.cart;
        const tickets = mergeProductQuantity(fixTickets, products, state.daysQuantity);

        commit(Constants.SET_FIX_TICKETS, {fixTickets: arrayToObjectLikeArray(tickets)});
        commit(Constants.SET_LOADING_STATUS, {status: false});
        Bus.$emit('select-calendar-day');
    },

    [Actions.setSelectedFixEvent]({commit}, payload) {
        commit(Constants.SET_SELECTED_FIX_EVENT, payload);
    },

    [Actions.removeSelectedFixEvent]({commit}) {
        commit(Constants.REMOVE_SELECTED_FIX_EVENT);
    }
};

export const stockDateActions = {
    [Actions.getStockDates]({commit}) {
        Endpoints.stock_date.get()
            .then(stockDates => {
                commit(Constants.SET_STOCK_DATES, stockDates['data']);
            })
            .catch(errors => console.log(`stock dates request fail`, errors));
    },
};



// WEBPACK FOOTER //
// ./src/store/actions.js